import withSplitting from './withSplitting';

export const noPage = withSplitting(() => import('./NoPage'));
export const error500 = withSplitting(() => import('./EventError500'));
export const error503 = withSplitting(() => import('./EventError'));
